import { useTranslation } from 'next-i18next';

import { FlowConfig } from '../../providers';
import { HowItWorksStep } from './components/HowItWorksStep';
import { OfferStep } from './components/OfferStep';
import { AddPaymentMethod } from './components/payment/AddPaymentMethod';
import { PaymentMethodSelector } from './components/payment/PaymentMethodSelector';
import { ReviewStep } from './components/ReviewStep';
import { AddShippingAddress } from './components/shipping/AddShippingAddress';
import { EditShippingAddress } from './components/shipping/EditShippingAddress';
import { ShippingAddressSelector } from './components/shipping/ShippingAddressSelector';

export const useOfferFlow = (product: ProductType): FlowConfig => {
  const { t } = useTranslation('product');

  return {
    containerId: 'stripe',
    name: 'offerFlow',
    steps: [
      {
        id: 'intro',
        title: t('drawers.offer.how_it_works.title'),
        hideSpacing: true,
        content: <HowItWorksStep />,
        analytics: {
          name: 'how it works',
        },
      },
      {
        id: 'offer',
        title: t('drawers.offer.title'),
        content: <OfferStep productVariantId={product.shopifyVariantId} />,
        analytics: {
          name: 'make an offer',
        },
      },
      {
        id: 'review',
        title: t('drawers.offer.review.title'),
        content: <ReviewStep product={product} />,
        analytics: {
          name: 'review offer',
        },
      },
      {
        analytics: {
          name: 'add address',
        },
        backStepId: 'select_shipping',
        id: 'add_shipping_address',
        content: <AddShippingAddress />,
        title: t('drawers.shipping.addTitle'),
      },
      {
        analytics: {
          name: 'edit address',
        },
        backStepId: 'review',
        id: 'edit_shipping_address',
        content: <EditShippingAddress />,
        title: t('drawers.review.draw.address.editAddress.title'),
      },
      {
        analytics: {
          name: 'address',
        },
        backStepId: 'review',
        content: <ShippingAddressSelector />,
        id: 'select_shipping',
        title: t('drawers.shipping.selectTitle'),
      },
      {
        analytics: {
          name: 'payment',
        },
        backStepId: 'review',
        id: 'select_payment_method',
        content: <PaymentMethodSelector />,
        title: t('drawers.payment.selectTitle'),
      },
      {
        analytics: {
          name: 'payment',
        },
        forceRender: true,
        backStepId: 'select_payment_method',
        id: 'add_payment_method',
        content: <AddPaymentMethod />,
        title: t('drawers.payment.addTitle'),
      },
    ],
  };
};
